module.exports = __webpack_public_path__ + "img/Image3.f3b95979.png";